import { api, providesList } from 'api';

export const workspaceAPI = api.injectEndpoints({
  endpoints: (build) => ({
    getWorkspaces: build.query({
      query: ({ userId }) => `/users/${userId}/workspaces`,
      providesTags: (result, error, args) => (result ? providesList(result, 'Workspace') : []),
      transformResponse: (response) => response.data,
    }),
    setWorkspace: build.mutation({
      queryFn: ({ workspaceId, workspaceName }, { getState, dispatch }) => ({
        data: { workspaceId, workspaceName },
      }),
      invalidatesTags: ['Office', 'ActivityFeed', 'Company', 'Notification'],
    }),
  }),
});
export const { useGetWorkspacesQuery, useSetWorkspaceMutation } = workspaceAPI;
